import styled from "styled-components";
export const Grow = styled.div `
  display: grid;

  &::after {
    content: attr(data-replicated-value) " ";
    white-space: pre-wrap;
    ${({ autoHeight }) => autoHeight ? "visibility: hidden" : "display: none"};
    grid-area: 1 / 1 / 2 / 2;
    border: 1px solid ${({ theme }) => theme.colors.grey10};
    font: inherit;
  }
`;
export const CharactersInfo = styled.span.attrs({
    className: "charactersInfoStyled",
}) `
  font-size: ${({ theme }) => theme.fontTokens.font14[0]};
  line-height: ${({ theme }) => theme.fontTokens.font14[1]};
  color: ${({ theme, error, currentValue }) => error && (currentValue === null || currentValue === void 0 ? void 0 : currentValue.length) !== 0
    ? theme.colors.error
    : theme.colors.grey13};
  position: absolute;
  right: 0;
`;
export const TextFieldStyle = styled.textarea `
  padding: 0.375rem 0.5rem;
  font-family: ${({ theme }) => theme.fontTokens.defaultFont};
  font-size: ${({ theme }) => theme.fontTokens.font12[0]};
  resize: ${({ autoHeight }) => (autoHeight ? "vertical" : "none")};
  min-height: 4.625rem;
  ${({ autoHeight }) => (!autoHeight ? "max-height: 4.625rem;" : "")};
  overflow-x: hidden;
  overflow-y: ${({ autoHeight }) => (autoHeight ? "hidden" : "scroll")};
  grid-area: 1 / 1 / 2 / 2;
  border: 1px solid
    ${({ errors, name, theme, selected }) => {
    if (errors === null || errors === void 0 ? void 0 : errors[name])
        return theme.colors.error;
    if (selected)
        return theme.colors.black;
    return theme.colors.grey10;
}};
  cursor: text;
  box-sizing: border-box;

  &::placeholder {
    color: rgba(${({ theme }) => theme.colors.transparent13}, 0.36);
  }

  &:read-only:not(:disabled),
  &:read-only:not(:disabled):hover {
    cursor: default;
    background-color: ${({ theme }) => theme.colors.grey04};
    border: 1px solid rgba(${({ theme }) => theme.colors.transparentBlack}, 0);
  }

  @media (hover: hover) {
    &:hover {
      ${({ theme, disabled, errors, name }) => !(errors === null || errors === void 0 ? void 0 : errors[name]) && !disabled
    ? `background-color: ${theme.colors.offWhite}`
    : ""};
      ${({ theme, selected, errors, name }) => !selected && !(errors === null || errors === void 0 ? void 0 : errors[name])
    ? `border: 1px solid ${theme.colors.grey14}`
    : ""};
    }
  }

  &:focus {
    ${({ theme, focused }) => focused ? `border: 1px solid ${theme.colors.primaryLight};` : ""};
    ${({ theme, focused }) => focused
    ? `outline: 1px solid ${theme.colors.primaryLight};`
    : "outline: none;"};
  }

  &:active {
    ${({ theme, readOnly, errors, name }) => !readOnly && !(errors === null || errors === void 0 ? void 0 : errors[name])
    ? `background-color: ${theme.colors.grey05};`
    : ""}
    ${({ theme, readOnly, errors, name }) => !readOnly && !(errors === null || errors === void 0 ? void 0 : errors[name])
    ? `border: 1px solid ${theme.colors.black};`
    : ""}
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.grey03};
    border: 1px solid rgba(${({ theme }) => theme.colors.transparentBlack}, 0);
    color: rgba(${({ theme }) => theme.colors.transparentBlack}, 0.26);
  }
`;
